export const OK = 200; // Success
export const CREATED = 201; // Success with result
export const BAD_REQUEST = 400; // Bad Request
export const UNAUTHORIZED = 401; // Unauthorized
export const CONFLICT = 409; // Conflict
export const DATA_NOT_FOUND = 404; //Data not found
export const EXPIRED = 410; //Token expired
